import actions from '@/store/modules/board/actions.js'
import getters from '@/store/modules/board/getters.js'
import mutations from '@/store/modules/board/mutations.js'

/**
 * @returns {object}
 */
const getDefaultState = () => ({
  boards: []
})

export default {
  actions,
  getters,
  mutations,
  state: getDefaultState()
}

export { getDefaultState }
